import React, { useMemo } from "react";
import WheelComponent from "../../../components/WheelComponent";
import { TextView } from "../../../components";
import SensorsIcon from "@mui/icons-material/Sensors";
import { colors } from "../../../utils";
import { Stack } from "@mui/material";

const styles = {
  card: {
    position: "relative",
    marginBottom: "3px",
    cursor: "pointer",
    border: "1px solid #E1E1E1",
    borderRadius: "10px",
    margin: "5px",
    backgroundColor: "white",
    height:"22vh",
    boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.1)",
    zIndex:10000
  },
  title: {
    fontWeight: "700",
    fontSize: "12px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "6px",
    lineHeight:"16px",
    color: colors.primary,
    textTransform: "capitalize",
  },
  wheelContainer: {
    backgroundColor: "#F6F7F9",
    height: "15vh",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sensorIcon: {
    color: "#FF7A5C",
    position: "absolute",
    top: 0,
    right: 0,
    margin: "4px",
  },
  wheelComponentContainer: {
    height:120,
    // width:150
  },
};

export default function WheelCard({ data, onWheelClick }) {
  const chartState = useMemo(() => {
    const wheelData = data?.wheel_section?.[0]?.activity_wheel;
    return wheelData
      ?.map((obj) => ({
        label: "blank",
        value: "1",
        isBlank: false,
        ...obj,
      }))
      ?.sort((a, b) => a.position - b.position);
  }, [data]);

  return (
    <Stack justifyContent={"space-between"} style={styles.card} onClick={() => onWheelClick(data)}>
      <TextView style={styles.title}>{data?.wheel_name ? data.wheel_name : "Untitled Wheel"}</TextView>
      <div style={{position:"relative",marginRight:"5px",marginLeft:"5px",marginBottom:"5px"}}> 
        <SensorsIcon style={styles.sensorIcon} />
        <div style={styles.wheelContainer}>
          <WheelComponent
            userData={{ id: Math.random() * 10, url: data?.wheel_image }}
            maxSelectedArcs={0}
            arcThickness={-10}
            margin={25}
            chartData={chartState}
            containerDivStyle={styles.wheelComponentContainer}
          />
        </div>
      </div>
    </Stack>
  );
}
